module.exports = __webpack_public_path__ + "img/1.75d092c6.jpg";